import { CalendarCrossChart, SafetyCrossDay, SafetyCrossLegend, SafetyCrossStatistics, StatBadge } from '@umanforge/common';
import ChartDisplay from 'components/charts/chartDisplay.component';
import { ChartWithDataApi } from 'interfaces/chartWithData.interface';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface VisualisationEventManagerChartsProps {
  charts: ChartWithDataApi[];
  safetyCross: {
    incidents: SafetyCrossDay[];
    stats: SafetyCrossStatistics;
  };
}

const cellStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  backgroundColor: '#FFFFFF',
  padding: '24px',
  borderRadius: '0.85rem'
};

const gridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  alignItems: 'center',
  columnGap: 24,
  rowGap: 12,
  justifyContent: 'center',
};

const SAFTY_CROSS_KEY = 'safety_cross';

function VisualisationEventManagerCharts( { charts, safetyCross }: VisualisationEventManagerChartsProps ) {

  const { t } = useTranslation();

  const [ cells, setCells ] = useState<{ key: string, title: string, element: JSX.Element }[]>( [] );

  useEffect( () => {

    const newCells: { key: string, title: string, element: JSX.Element }[] = [];
    newCells.push( { key: SAFTY_CROSS_KEY, title: t( 'safety_cross' ), element: (
      <div style={ gridStyle }>
        <div className='flex flex-col gap-4'>
          <SafetyCrossLegend />
          <div className='flex flex-col gap-2'>
            <StatBadge
              label={ t( 'common:safetyCross.currentConsecutiveDays' ) }
              value={safetyCross.stats.currentConsecutiveDays ?? 0}
              className="w-full"
            />
            <StatBadge
              label={ t( 'common:safetyCross.bestConsecutiveDays' ) }
              value={safetyCross.stats.bestConsecutiveDays ?? 0}
              className="w-full"
            />
          </div>
        </div>
        <CalendarCrossChart
          disabled={ true }
          canChangeDate={ false }
          data={ safetyCross.incidents }
        />
      </div>
    ) } );

    for ( const chart of charts ) {
      newCells.push( { key: 'chart_' + chart.id, title: chart.chartSection.name, element: <ChartDisplay chart={ chart }/> } );
    }

    setCells( newCells );
  }, [ charts, safetyCross ] );

  return (
    <div className='flex flex-wrap w-full gap-4 -4 justify-left text-balance truncate'>

      {
        cells.map( cell => {
          return (
            <div key={ cell.key } style={ cellStyle } className='w-[100%] xl:w-[calc(50%-1rem)] shadow'>
              <div className='font-bold'>
                { cell.title }
              </div>
              <div className='w-full h-1 px-2 rounded-full bg-blue-600/90'/>
              <div className='flex'>
              </div>
              { cell.element }
            </div>
          );
        } )
      }

    </div>
  );
}

export default VisualisationEventManagerCharts;
